import { useEffect } from 'react'

export default function SEO({ title, description, ogImage, canonicalUrl }) {
  useEffect(() => {
    let fullTitle = title || 'Docuit ink | Tatovør & Tatoveringsstudie i Vester Sottrup nær Sønderborg'
    document.title = fullTitle

    const metaDescription = description || 'Leder du efter en professionel tatovør i Vester Sottrup nær Sønderborg? Hos Docuit ink skaber jeg unikke, skræddersyede tatoveringer med fokus på høj hygiejne og kunstnerisk håndværk.'
    
    // Standard Meta Description
    let metaDescTag = document.querySelector('meta[name="description"]')
    if (!metaDescTag) {
      metaDescTag = document.createElement('meta')
      metaDescTag.name = 'description'
      document.head.appendChild(metaDescTag)
    }
    metaDescTag.content = metaDescription

    // OpenGraph Title
    let ogTitleTag = document.querySelector('meta[property="og:title"]')
    if (!ogTitleTag) {
      ogTitleTag = document.createElement('meta')
      ogTitleTag.setAttribute('property', 'og:title')
      document.head.appendChild(ogTitleTag)
    }
    ogTitleTag.content = fullTitle

    // OpenGraph Description
    let ogDescTag = document.querySelector('meta[property="og:description"]')
    if (!ogDescTag) {
      ogDescTag = document.createElement('meta')
      ogDescTag.setAttribute('property', 'og:description')
      document.head.appendChild(ogDescTag)
    }
    ogDescTag.content = metaDescription

    // OpenGraph Image
    const defaultImage = 'https://assets.auxodev.dk/assets/b7bd9965-d19c-45c5-aaa1-9572b70fbe0d/ingen-tilgaengelig-billedbeskrivelse.png'
    let ogImageTag = document.querySelector('meta[property="og:image"]')
    if (!ogImageTag) {
      ogImageTag = document.createElement('meta')
      ogImageTag.setAttribute('property', 'og:image')
      document.head.appendChild(ogImageTag)
    }
    ogImageTag.content = ogImage || defaultImage

    // OpenGraph Type
    let ogTypeTag = document.querySelector('meta[property="og:type"]')
    if (!ogTypeTag) {
      ogTypeTag = document.createElement('meta')
      ogTypeTag.setAttribute('property', 'og:type')
      document.head.appendChild(ogTypeTag)
    }
    ogTypeTag.content = 'website'

    // Twitter Card
    let twitterCardTag = document.querySelector('meta[name="twitter:card"]')
    if (!twitterCardTag) {
      twitterCardTag = document.createElement('meta')
      twitterCardTag.name = 'twitter:card'
      document.head.appendChild(twitterCardTag)
    }
    twitterCardTag.content = 'summary_large_image'

    // Twitter Title
    let twitterTitleTag = document.querySelector('meta[name="twitter:title"]')
    if (!twitterTitleTag) {
      twitterTitleTag = document.createElement('meta')
      twitterTitleTag.name = 'twitter:title'
      document.head.appendChild(twitterTitleTag)
    }
    twitterTitleTag.content = fullTitle

    // Twitter Description
    let twitterDescTag = document.querySelector('meta[name="twitter:description"]')
    if (!twitterDescTag) {
      twitterDescTag = document.createElement('meta')
      twitterDescTag.name = 'twitter:description'
      document.head.appendChild(twitterDescTag)
    }
    twitterDescTag.content = metaDescription

    // Twitter Image
    let twitterImageTag = document.querySelector('meta[name="twitter:image"]')
    if (!twitterImageTag) {
      twitterImageTag = document.createElement('meta')
      twitterImageTag.name = 'twitter:image'
      document.head.appendChild(twitterImageTag)
    }
    twitterImageTag.content = ogImage || defaultImage

    // Canonical link
    if (canonicalUrl) {
      let canonicalTag = document.querySelector('link[rel="canonical"]')
      if (!canonicalTag) {
        canonicalTag = document.createElement('link')
        canonicalTag.setAttribute('rel', 'canonical')
        document.head.appendChild(canonicalTag)
      }
      canonicalTag.setAttribute('href', canonicalUrl)
    }

  }, [title, description, ogImage, canonicalUrl])

  return null
}
